import type { Styles } from '@adornis/ass/style.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { Product } from '../../db/product/Product.js';
import { productTypeIcon } from '../../db/product/enums.js';
import { ensureProperty } from '../helpers.js';
import '../theme/d-icon.js';

@customElement('component-product-icon-text')
export class ComponentProductIconText extends ChemistryLitElement {
  @property({ attribute: false }) product: Maybe<Product>;

  override render() {
    const product = ensureProperty(this, this.product);
    const styling = { color: this.colors.tone.secondaryText, fontSize: '14px' } as Styles;

    return html`
      <d-flex horizontal space="sm" crossaxis-center>
        <d-icon ${css(styling)}> ${productTypeIcon(product.type)} </d-icon>
        <d-text ${css(styling)}> ${product.type} </d-text>
      </d-flex>
    `;
  }
  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          // display: 'contents',
        },
      },
    ] as Styles[];
  }
}
